import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ManageSorteoView from "../manageSorteo/ManageSorteoView";
import PatronesView from "../PatronesView/PatronesView";
import "./GestionBingoView.css";
import ManagePagoView from "../managePagos/ManagePagoView";
import ManageTickectsView from "../manageTickets/ManageTickectsView";

const API_URL = process.env.REACT_APP_API_URL;

const GestionBingoView = () => {
  const navigate = useNavigate();
  const [sorteos, setSorteos] = useState([]);

  const handleUnauthorized = () => {
    localStorage.removeItem("access_token");
    navigate("/login");
  };

  const fetchSorteos = async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      handleUnauthorized();
      return;
    }

    const res = await fetch(`${API_URL}/sorteos_disponibles/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (res.status === 401 || res.status === 403) {
      handleUnauthorized();
      return;
    }

    const data = await res.json();
    setSorteos(data);
  };

  useEffect(() => {
    fetchSorteos(); // Esta es la función del padre

    // Polling cada 5 segundos para mantener sincronizados los módulos
    const interval = setInterval(() => {
      fetchSorteos();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="paneles-container">
      <div className="panel">
        <h2>🎟️ Gestión de Sorteos</h2>
        <ManageSorteoView sorteos={sorteos} refresh={fetchSorteos} />
      </div>

      <div className="panel">
        <h2>📋 Gestión de Patrones</h2>
        <PatronesView fetchSorteos={fetchSorteos} />
      </div>

      <div className="panel">
        <h2>🧾 Gestión de Pagos</h2>
        <ManagePagoView />
      </div>
      <div className="panel">
        <h2>🎫 Gestión de Tickets Ganadores</h2>
        <ManageTickectsView />
      </div>
    </div>
  );
};

export default GestionBingoView;
